import { any, defaultTo, pluck, not, toLower } from 'ramda';
import { HydratedTextFilter, HydratedItemFilter } from '@/filter/types';

import contains from './utils/contains';
import hasAny from './utils/hasAny';
import hasAll from './utils/hasAll';
import equalsIgnoreOrder from './utils/equalsIgnoreOrder';

const filterFunctions: {
  text: {
    contains: (filter: HydratedTextFilter) => (item: any) => boolean;
    notcontain: (filter: HydratedTextFilter) => (item: any) => boolean;
  };
  item: {
    hasany: (filter: HydratedItemFilter) => (item: any) => boolean;
    hasnone: (filter: HydratedItemFilter) => (item: any) => boolean;
    hasall: (filter: HydratedItemFilter) => (item: any) => boolean;
    hasnothing: (filter: HydratedItemFilter) => (item: any) => boolean;
    is: (filter: HydratedItemFilter) => (item: any) => boolean;
    contains: (filter: HydratedItemFilter) => (item: any) => boolean;
    notcontain: (filter: HydratedItemFilter) => (item: any) => boolean;
  };
} = {
  text: {
    contains: (filter) => (item) => contains(toLower(filter.value.value), toLower(filter.getText(item))),
    notcontain: (filter) => (item) => not(contains(toLower(filter.value.value), toLower(filter.getText(item)))),
  },

  item: {
    hasany: (filter) => (item) => hasAny(filter.value.value, pluck('id', filter.getItems(item))),
    hasnone: (filter) => (item) => not(hasAny(filter.value.value, pluck('id', filter.getItems(item)))),
    hasnothing: (filter) => (item) => not(filter.getItems(item).length),
    hasall: (filter) => (item) => hasAll(filter.value.value, pluck('id', filter.getItems(item))),
    is: (filter) => (item) => equalsIgnoreOrder(filter.value.value, pluck('id', filter.getItems(item))),
    contains: (filter) => (item) =>
      any(
        (subItem) => contains(toLower(filter.value.value as string), toLower(defaultTo('', filter.getText(subItem)))),
        filter.getItems(item)
      ),
    notcontain: (filter) => (item) =>
      not(
        any(
          (subItem) => contains(toLower(filter.value.value as string), toLower(defaultTo('', filter.getText(subItem)))),
          filter.getItems(item)
        )
      ),
  },
};

export default filterFunctions;
